export const ThreatVulnerabilityIcon = () => (
  <svg width="160" height="160" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="30" stroke="white" strokeWidth="2" fill="none" />
    <circle cx="32" cy="35" r="8" stroke="white" strokeWidth="1.5" fill="none" />
    <circle cx="48" cy="35" r="8" stroke="white" strokeWidth="1.5" fill="none" />
    <path d="M 25 55 L 35 45 M 55 55 L 45 45" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <circle cx="20" cy="25" r="3" fill="white" />
    <circle cx="60" cy="60" r="3" fill="white" />
  </svg>
);

export const GovernanceRiskIcon = () => (
  <svg width="160" height="160" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="20" y="25" width="40" height="35" stroke="white" strokeWidth="2" fill="none" rx="4" />
    <path d="M 30 38 L 32 35" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M 40 38 L 40 32" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M 50 38 L 48 33" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <line x1="25" y1="48" x2="55" y2="48" stroke="white" strokeWidth="1" />
    <line x1="25" y1="54" x2="55" y2="54" stroke="white" strokeWidth="1" />
    <circle cx="28" cy="28" r="2" fill="white" />
    <circle cx="55" cy="65" r="3" fill="white" />
  </svg>
);

export const CybersecurityArchitectureIcon = () => (
  <svg width="160" height="160" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="25" stroke="white" strokeWidth="1.5" fill="none" />
    <circle cx="30" cy="25" r="3" fill="white" />
    <circle cx="50" cy="25" r="3" fill="white" />
    <circle cx="55" cy="40" r="3" fill="white" />
    <circle cx="50" cy="55" r="3" fill="white" />
    <circle cx="30" cy="55" r="3" fill="white" />
    <circle cx="25" cy="40" r="3" fill="white" />
    <circle cx="40" cy="35" r="3" fill="white" />
    <circle cx="40" cy="45" r="3" fill="white" />
    <line x1="30" y1="25" x2="50" y2="25" stroke="white" strokeWidth="1" />
    <line x1="50" y1="25" x2="55" y2="40" stroke="white" strokeWidth="1" />
    <line x1="55" y1="40" x2="50" y2="55" stroke="white" strokeWidth="1" />
    <line x1="50" y1="55" x2="30" y2="55" stroke="white" strokeWidth="1" />
    <line x1="30" y1="55" x2="25" y2="40" stroke="white" strokeWidth="1" />
    <line x1="25" y1="40" x2="30" y2="25" stroke="white" strokeWidth="1" />
  </svg>
);

export const ManagedSOCIcon = () => (
  <svg width="160" height="160" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M 25 35 Q 25 25 35 25 Q 45 25 45 35 Q 45 40 42 43" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d="M 35 50 Q 35 45 40 45 Q 45 45 45 50 Q 45 55 40 58 Q 35 55 35 50" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
    <line x1="40" y1="29" x2="40" y2="32" stroke="white" strokeWidth="1.5" />
    <path d="M 50 30 L 55 25 M 55 25 L 58 28 M 58 28 L 53 33" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="40" cy="52" r="12" stroke="white" strokeWidth="1.5" fill="none" />
  </svg>
);

export const CyberAwarenessIcon = () => (
  <svg width="160" height="160" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="20" y="28" width="40" height="28" stroke="white" strokeWidth="2" fill="none" rx="2" />
    <rect x="20" y="56" width="40" height="3" fill="white" />
    <circle cx="40" cy="42" r="6" stroke="white" strokeWidth="1.5" fill="none" />
    <path d="M 35 42 L 40 48 L 45 42" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <circle cx="60" cy="42" r="10" stroke="white" strokeWidth="1.5" fill="none" />
    <path d="M 60 35 L 60 49 M 53 42 L 67 42" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const DataGovernanceIcon = () => (
  <svg width="160" height="160" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="18" y="20" width="44" height="40" stroke="white" strokeWidth="2" fill="none" rx="2" />
    <line x1="18" y1="32" x2="62" y2="32" stroke="white" strokeWidth="1" />
    <line x1="18" y1="44" x2="62" y2="44" stroke="white" strokeWidth="1" />
    <circle cx="25" cy="26" r="2" fill="white" />
    <circle cx="35" cy="26" r="2" fill="white" />
    <circle cx="25" cy="38" r="2" fill="white" />
    <circle cx="35" cy="38" r="2" fill="white" />
  </svg>
);

const iconMap = {
  0: ThreatVulnerabilityIcon,
  1: GovernanceRiskIcon,
  2: CybersecurityArchitectureIcon,
  3: ManagedSOCIcon,
  4: CyberAwarenessIcon,
  'data-governance': DataGovernanceIcon,
  'data-strategy': GovernanceRiskIcon,
  'modern-data': DataGovernanceIcon,
};

export const getIconForService = (index, slug) => {
  const slugKey = slug?.split('-').slice(0, 2).join('-');
  return iconMap[slugKey] || iconMap[index % 5] || DataGovernanceIcon;
};
